import { render } from "./BathroomsCreating.vue?vue&type=template&id=3e36275f&ts=true"
import script from "./BathroomsCreating.vue?vue&type=script&lang=ts"
export * from "./BathroomsCreating.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__